import { render, staticRenderFns } from "./ShipmentSearch.vue?vue&type=template&id=6257b408&scoped=true"
import script from "./ShipmentSearch.vue?vue&type=script&lang=js"
export * from "./ShipmentSearch.vue?vue&type=script&lang=js"
import style0 from "./ShipmentSearch.vue?vue&type=style&index=0&id=6257b408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257b408",
  null
  
)

export default component.exports